import { gql } from "@apollo/client";

export const GET_SERIES_BY_ID_QUERY = gql`
  query SeriesById($id: String) {
    seriesById(_id: $id) {
      _id
      modality
      series_instance_uid
      description
      acquisition
      addition
      instance_ids
    }
  }
`;

export const GET_SERIES_LIST_BY_IDS_QUERY = gql`
  query SeriesByIds($ids: [String]) {
    seriesByIds(ids: $ids) {
      _id
      modality
      acquisition
      addition
      description
      instance_ids
    }
  }
`;

export const GET_INSTANCE_IDS_BY_SERIES_IDS_QUERY = gql`
  query InstanceIdsBySeriesIds($ids: [String]) {
    seriesByIds(ids: $ids) {
      _id
      instance_ids
    }
  }
`;

export const GET_SERIES_UIDS_BY_IDS_QUERY = gql`
  query SeriesUidsByIds($ids: [String]) {
    seriesByIds(ids: $ids) {
      _id
      series_instance_uid
    }
  }
`;
